import { render, staticRenderFns } from "./VueNavigation.vue?vue&type=template&id=44cda45c&"
import script from "./VueNavigation.vue?vue&type=script&lang=js&"
export * from "./VueNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports